module.exports = __webpack_public_path__ + "static/vmware-6226e22fd7309f6d9ee20cb4baee94ff.png";